import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "../components/Reveal";
import Marquee from "../components/Marquee";
import Seo from "../components/Seo";
import { STEPS } from "../data/content";

export default function HowItWorks() {
  return (
    <div data-testid="how-it-works-page" className="pt-32 md:pt-44">
      <Seo
        title="How It Works | Quexify Transaction Coordination"
        description="A calm four-step handoff: discovery call, matched and trained operator, and your time back. See how a Quexify transaction coordinator gets live within days."
        path="/how-it-works"
      />
      <section className="max-w-[1400px] mx-auto px-6 md:px-10">
        <Reveal>
          <h1 className="font-display text-5xl md:text-8xl tracking-tighter font-medium leading-[0.9] max-w-4xl">
            A calm, four-step handoff.
          </h1>
          <p className="mt-8 text-lg md:text-xl text-neutral-500 max-w-2xl leading-relaxed">
            No rip-and-replace. We embed into the tools and workflows you already use, then quietly take the operational load off your team.
          </p>
        </Reveal>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-32">
        <div className="border-t border-black/10">
          {STEPS.map((step, i) => (
            <Reveal key={step.n} delay={i * 0.05}>
              <div className="group grid md:grid-cols-12 gap-6 py-12 md:py-16 border-b border-black/10 items-start">
                <div className="md:col-span-3 font-display text-6xl md:text-8xl tracking-tighter text-neutral-200 group-hover:text-black transition-colors duration-500">{step.n}</div>
                <h2 className="md:col-span-5 font-display text-2xl md:text-4xl tracking-tight font-medium">{step.title}</h2>
                <p className="md:col-span-4 text-neutral-500 text-lg leading-relaxed">{step.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="border-y border-black/5 bg-[#fafafa]"><Marquee /></section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-40 text-center">
        <Reveal>
          <h2 className="font-display text-4xl md:text-7xl tracking-tighter font-medium leading-[0.95] max-w-3xl mx-auto">
            See it running on your pipeline.
          </h2>
          <Link to="/book-demo" className="mt-12 inline-flex items-center gap-2 rounded-full bg-[#0a0a0a] text-white px-9 py-4 text-lg transition-transform duration-300 hover:-translate-y-0.5" data-testid="how-cta">
            Book a discovery call <ArrowUpRight size={20} />
          </Link>
        </Reveal>
      </section>
    </div>
  );
}
